import { ReactNode } from 'react'
import { Button } from '@mui/material'

interface Props {
  label: string
  icon: ReactNode
  disabled?: boolean
  onFileSelected: (file: File) => void
}

const UploadAttachmentButton = ({ label, icon, disabled, onFileSelected }: Props) => (
  <Button size="small" variant="outlined" component="label" startIcon={icon} disabled={disabled}>
    {label}
    <input
      hidden
      type="file"
      accept=".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      onChange={event => {
        const file = event.target.files?.[0]
        if (file) onFileSelected(file)
        event.target.value = ''
      }}
    />
  </Button>
)

export default UploadAttachmentButton
